
export default {
  name: 'EducationMenuItem',

  props: {
    isUseNuxtLink: {
      type: Boolean,
      default: false
    },

    isSelected: {
      type: Boolean,
      default: false
    },

    isDisabled: {
      type: Boolean,
      default: false
    },

    counter: {
      type: Number,
      default: null
    },

    link: {
      type: String,
      default: ''
    },

    title: {
      type: String,
      default: ''
    },

    icon: {
      type: String,
      default: ''
    }
  },

  computed: {
    isDisabledNuxtLink() {
      const { isDisabled, isSelected, link } = this

      return isDisabled || isSelected || !link
    },

    digitFormat() {
      if (this.counter) {
        return this.counter > 999
          ? this.counter.toString().slice(0, -3) + 'k'
          : this.counter
      }

      return null
    }
  }
}
